import React, { Component } from 'react';
import { Box, Typography, Button, Container, Paper, Icon } from '@mui/material';
import { COLORS } from '../theme/tibiaTheme';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary capturou um erro:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="md" sx={{ py: 8 }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              textAlign: 'center',
              background: 'linear-gradient(145deg, #2d2d2d 0%, #1a1a1a 100%)',
              border: '2px solid #EF4444',
              borderRadius: '12px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 3,
              }}
            >
              <Icon
                className="material-symbols-outlined"
                sx={{
                  fontSize: '5rem',
                  color: COLORS.error,
                }}
              >
                error_outline
              </Icon>
              <Typography
                variant="h4"
                sx={{
                  color: COLORS.error,
                  fontWeight: 'bold',
                }}
              >
                Algo deu errado!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: COLORS.onSurface,
                  maxWidth: '600px',
                }}
              >
                Desculpe, ocorreu um erro inesperado na aplicação. Tente recarregar a página.
              </Typography>

              {process.env.NODE_ENV === 'development' && this.state.error && (
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    backgroundColor: 'rgba(239, 68, 68, 0.1)',
                    border: `1px solid ${COLORS.error}`,
                    borderRadius: '8px',
                    textAlign: 'left',
                    width: '100%',
                    maxWidth: '600px',
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: COLORS.onSurface,
                      fontFamily: 'monospace',
                      fontSize: '0.85rem',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                    }}
                  >
                    <strong>Erro:</strong> {this.state.error.toString()}
                  </Typography>
                  {this.state.errorInfo && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: COLORS.onSurfaceVariant,
                        fontFamily: 'monospace',
                        fontSize: '0.75rem',
                        mt: 1,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                      }}
                    >
                      {this.state.errorInfo.componentStack}
                    </Typography>
                  )}
                </Box>
              )}

              <Button
                variant="contained"
                startIcon={<Icon className="material-symbols-outlined">refresh</Icon>}
                onClick={this.handleReset}
                sx={{
                  mt: 2,
                  backgroundColor: COLORS.error,
                  color: COLORS.onPrimary,
                  fontWeight: 'bold',
                  px: 4,
                  py: 1.5,
                  '&:hover': {
                    backgroundColor: '#DC2626',
                  },
                }}
              >
                Recarregar Página
              </Button>
            </Box>
          </Paper>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
